import vars from '../helpers';
import scrollDepth from 'scroll-depth';

const start15SecTimeout = () => {
	clearTimeout(vars.$window.data('timeout15Sec'));

	vars.$window.data('timeout15Sec', setTimeout(() => {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
};

start15SecTimeout();

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
	},
});

/**
* Создать куки запись
* @param {string} path Обязательное, ссылка/путь
*/
const virtualHit = (path) => {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}
};

$('.js-logo-partner').on('click', () => {
	ga('send', 'event', 'client link', 'logo header');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.js-logo-rbc').on('click', () => {
	ga('send', 'event', 'nav', 'rbc logo');
});

$('.js-menu-link').on('click', (e) => {
	const name = $(e.currentTarget).closest('.js-menu-item').find('.js-menu-text').text();

	ga('send', 'event', 'nav', 'menu item click', name);
});

$('.js-home-links').on('click', (e) => {
	const name = $(e.currentTarget).find('.js-home-texts').text();

	ga('send', 'event', 'main', 'material click', name);
});

$('.js-start-button').on('click', () => {
	ga('send', 'event', 'game', 'start');
});

$('.js-social-finish').on('click', (e) => {
	const name = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'game share', name);
});

$('.js-also-finish').on('click', () => {
	ga('send', 'event', 'client link', 'game final link');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.js-also-link').on('click', (e) => {
	const type = $(e.currentTarget).attr('href') === '/' ? 'main' : 'game';

	ga('send', 'event', 'article', 'go to', type);
});

$('.js-social').on('click', (e) => {
	const name = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'project share', name);
});

vars.$html
	.on('check-click', (e, type, left, right) => {
		ga('send', 'event', 'game', `create a pair ${type}`, `${left} - ${right}`);
	})
	.on('show-answer-window', (e, name) => {
		ga('send', 'event', 'game', 'comment show', name, {nonInteraction: true});
	})
	.on('show-final-screen', () => {
		ga('send', 'event', 'game', 'finish', '', {nonInteraction: true});
	})
	.on('video-popup-open', (e, name) => {
		ga('send', 'event', 'article', 'video click', name);
	})
	.on('video-play', (e, name) => {
		ga('send', 'event', 'video', 'play', name, {nonInteraction: true});
		ga('rbcspec.send', 'event', 'video', 'play', {nonInteraction: true});
	})
	.on('video-ended', (e, name) => {
		ga('send', 'event', 'video', 'finish', name);
		ga('rbcspec.send', 'event', 'video', 'finish');
	})
	.on('video-interval-30', (e, name) => {
		ga('send', 'event', 'video', 'timing 30s', name, 30);
		ga('rbcspec.send', 'event', 'video', 'timing 30s', '', 30);
	})
;

export default {
	start15SecTimeout,
	virtualHit,
};
